import React, { useState, useEffect } from "react";
import "./usereditmodal.css";
import { Modal, Button } from "react-bootstrap";
import { message, Select } from "antd";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Instance from "../../../AxiosConfig";

const UserEditModal = ({ show, handleClose, user, fetchUsers }) => {
  const [formData, setFormData] = useState({
    userName: "",
    userPhoneNumber: "",
    role: "",
    userEmail: ""
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});



// Populate when user becomes available AND modal is open
useEffect(() => {
  if (show && user) {
    const userName = user.userName ?? user.name ?? "";
    const userPhoneNumber = user.userPhoneNumber ?? user.phone ?? user.mobile ?? "";
    const role = user.role ?? "";
    const userEmail = user.userEmail ?? user.email ?? "";

     
    setFormData({
      userName,
      userPhoneNumber: "",  
      role,
      userEmail
    });

    // Set phone number after a brief delay
    setTimeout(() => {
      setFormData(prev => ({
        ...prev,
        userPhoneNumber
      }));
    }, 50);
  }
}, [user, show]);

  // Reset when modal closes to avoid stale data
  useEffect(() => {
    if (!show) {
      setFormData({
        userName: "",
        userPhoneNumber: "",
        role: "",
        userEmail: ""
      });
      setErrors({});
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.userName.trim()) newErrors.userName = "Name is required.";
    if (!String(formData.userPhoneNumber).trim()) newErrors.userPhoneNumber = "Phone number is required.";
    if (!formData.role) newErrors.role = "Role is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditUser = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const id = user?._id ?? user?.id;
      if (!id) {
        message.error("User id not found.");
        return;
      }

      const payload = {
        userName: formData.userName,
        userPhoneNumber: formData.userPhoneNumber,
        role: formData.role,
        userEmail: formData.userEmail
      };

      // Debugging: log payload
      // eslint-disable-next-line no-console
      console.log("Updating user", id, payload);

      const response = await Instance.put(`/users/${id}`, payload);
      if (response.status === 200 || response.status === 201) {
        message.success("User updated successfully.");
        handleClose();
        if (typeof fetchUsers === "function") fetchUsers();
      } else {
        message.error("Failed to update user.");
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error updating user:", error);
      message.error("Error updating user. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleEditUser();
          }}
        >
          <div className="container-fluid">
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="userName"
                  value={formData.userName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter full name"
                />
                {errors.userName && <small className="text-danger">{errors.userName}</small>}
              </div>

              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="userEmail"
                  value={formData.userEmail}
                  onChange={handleChange}
                  readOnly
                  className="form-control"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
  <label className="form-label">Phone Number</label>
  {show && formData.userPhoneNumber && (
    <PhoneInput
      key={user?._id}
      defaultCountry="in"
      value={formData.userPhoneNumber}
      onChange={(phone) => setFormData((prev) => ({ ...prev, userPhoneNumber: phone }))}
      className="w-100"
      placeholder="Enter phone number"
    />
  )}
  {show && !formData.userPhoneNumber && (
    <PhoneInput
      defaultCountry="in"
      value=""
      onChange={(phone) => setFormData((prev) => ({ ...prev, userPhoneNumber: phone }))}
      className="w-100"
      placeholder="Enter phone number"
    />
  )}
  {errors.userPhoneNumber && <small className="text-danger">{errors.userPhoneNumber}</small>}
</div>

              <div className="col-md-6">
                <label className="form-label">Role</label>
                <Select
                  placeholder="Select Role"
                  value={formData.role || null}
                  onChange={(value) => setFormData((prev) => ({ ...prev, role: value }))}
                  style={{ width: "100%" }}
                  options={[
                    { label: "Admin", value: "admin" },
                    { label: "Editor", value: "editor" }
                  ]}
                />
                {errors.role && <small className="text-danger">{errors.role}</small>}
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button type="button" className="users-discard-button" onClick={handleClose}>
                Discard
              </button>
              <button type="submit" className="users-save-button" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UserEditModal;
